import { selectCtx as e, selectEvents as t } from "../core/models/selectors/index.js";
import { useDatePickerStore as n } from "../core/models/use-date-picker-store.js";
import { EnFlag as r } from "./flags/english/index.js";
import { NpFlag as i } from "./flags/nepali/index.js";
import { cn as a } from "../../../cn.js";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { Else as c, If as l, Then as u } from "react-if";
// src/design/forms/datepicker/ui/context-toggle.tsx
var d = ({ children: d }) => {
	let { isNepali: f, showToggle: p } = n(e), m = n(t);
	return p ? d || /* @__PURE__ */ o("button", {
		type: "button",
		"aria-label": "Bikram Sambat calendar",
		"aria-pressed": !!f,
		onClick: (e) => {
			e.preventDefault(), m.toggleContext();
		},
		className: a("shrink-0 w-8 h-8 flex items-center justify-center", "transition-all duration-fast", "bg-transparent hover:bg-muted rounded-md", "focus-ring", { "border-r border-r-border": !1 }),
		children: /* @__PURE__ */ s(l, {
			condition: f,
			children: [/* @__PURE__ */ o(u, { children: /* @__PURE__ */ o("div", {
				className: "w-4 h-4",
				children: /* @__PURE__ */ o(i, {})
			}) }), /* @__PURE__ */ o(c, { children: /* @__PURE__ */ o("div", {
				className: "w-4 h-4",
				children: /* @__PURE__ */ o(r, {})
			}) })]
		})
	}) : null;
};
export { d as ContextToggler };

//# sourceMappingURL=context-toggle.js.map